import { createApp } from 'vue';
import App from './App.vue';
import PrimeVue from 'primevue/config';
import Button from 'primevue/button';
import Panel from './components/CustomPanel';
import InputText from 'primevue/inputtext';
import InputSwitch from 'primevue/inputswitch';
import Dropdown from 'primevue/dropdown';
import ProgressSpinner from 'primevue/progressspinner';
import AutoComplete from 'primevue/autocomplete';
import Slider from 'primevue/slider';
import Checkbox from 'primevue/checkbox';
import ToggleButton from 'primevue/togglebutton';
import PrimeTooltip from 'primevue/tooltip';
import Tooltip from "./components/Tooltip"
import Textarea from 'primevue/textarea';
import ProgressBar from 'primevue/progressbar';
import Divider from 'primevue/divider';
import Sidebar from "primevue/sidebar";
import Timeline from "primevue/timeline";
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Password from 'primevue/password';
import CustomDialog from './components/CustomDialog.vue';
import BadgeDirective from 'primevue/badgedirective';
import Badge from 'primevue/badge';
import RadioButton from 'primevue/radiobutton';
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';
import Toast from 'primevue/toast';
import MultiSelect from 'primevue/multiselect';

import { pinia } from '@/stores/pinia';
import router from './router';
import { i18nInstance } from './i18n';
import VueDOMPurifyHTML from 'vue-dompurify-html';
import { setupAuth } from './auth';

import './assets/layout/all.scss';

const app = createApp(App);

app.directive('tooltip', PrimeTooltip);

app.use(pinia);
app.use(router);
app.use(i18nInstance);
app.use(VueDOMPurifyHTML, {
    namedConfigurations: {
        plaintext: {
            USE_PROFILES: { html: false },
        },
    },
});

app.use(PrimeVue, {
    locale: {
        firstDayOfWeek: 1,
        dayNames: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
        dayNamesShort: ["Son", "Mon", "Die", "Mit", "Don", "Fre", "Sam"],
        dayNamesMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
        monthNames: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
        monthNamesShort: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
    }
});

app.component('Button', Button);
app.component('Dialog', CustomDialog);
app.component('Panel', Panel);
app.component('ProgressSpinner', ProgressSpinner);
app.component('InputText', InputText);
app.component('InputSwitch', InputSwitch);
app.component('Dropdown', Dropdown);
app.component('AutoComplete', AutoComplete);
app.component('Checkbox', Checkbox);
app.component('ToggleButton', ToggleButton);
app.component('Slider', Slider);
app.component('Toast', Toast);   
app.component('Textarea', Textarea);
app.component('ProgressBar', ProgressBar);
app.component('Sidebar', Sidebar);
app.component('Timeline', Timeline);
app.component('Divider', Divider);
app.component('Accordion', Accordion);
app.component('AccordionTab', AccordionTab);
app.component('Password', Password);
app.component('RadioButton', RadioButton);
app.component('Badge', Badge);
app.component('Tooltip', Tooltip);
app.component('MultiSelect', MultiSelect);

app.directive('badge', BadgeDirective);

app.use(ConfirmationService);
app.use(ToastService);

const auth = setupAuth();
app.use(auth);
app.mount('#app');